import { useContext } from 'react';
import './division.css';
import SelectCompanie from '../SelectCompanie';
import { AuthContext } from '../../contexts/auth';
import "react-bootstrap-submenu/dist/index.css";

import { Link } from 'react-router-dom';
import { FaSignInAlt } from "react-icons/fa";

export default function Division(){
  const { signOut, companies } = useContext(AuthContext);

  return(
    <div className="division">
      
    </div>
  )
}